import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyObject, ErrorMessage } from '@mri/types';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { toDateFormat } from '@mri/functions';

@Component({
  selector: 'app-field-date-range',
  templateUrl: './field-date-range.component.html',
  styleUrl: './field-date-range.component.scss'
})
export class FieldDateRangeComponent {
  private _classSet: Set<string> = new Set<string>();
  values: Array<Date| string | number> = [];
  private _block: boolean;

  @Output() startValueChange = new EventEmitter<string>;
  @Output() endValueChange = new EventEmitter<string>;
  @Input() placeholder?: string;

  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;
  @Input() image?: string | ((value: string) => string);

  @Input() set startValue(value: string | number) {
    if (this._block) return;
    this.values[0] = new Date(`${value}T00:00`);
  }

  @Input() set endValue(value: Date | string | number) {
    if (this._block) return;
    this.values[1] = new Date(`${value}T00:00`);
  }

  get classes(): string {
    return [...this._classSet].join(' ');
  }

  onStartChange(event: MatDatepickerInputEvent<AnyObject>) {
    this._blockComponent();
    this.startValueChange.emit(toDateFormat(event.target.value));
  }

  onEndChange(event: MatDatepickerInputEvent<AnyObject>) {
    this._blockComponent()
    this.endValueChange.emit(toDateFormat(event.target.value));
  }

  onFocus() {
    this._classSet.add('card-focus');
  }

  onBlur() {
    this._classSet.delete('card-focus');
  }

  private _blockComponent(){
    this._block = true;
    setTimeout(() => this._block = false, 100);
  }

}
